import AdminLayout from "../../../components/admin/layout/AdminLayout";
import BuyerList from "../../../components/admin/buyer/BuyerList";

function BuyerListPage() {
  return (
    <AdminLayout>
      <BuyerList />
    </AdminLayout>
  );
}

export default BuyerListPage;
